<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" epub:type="epigraph" id="epigraph">
<div class="text" id="epigraph-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left epigraph-content"><i>The person, be it gentleman or lady, who has not</i></p>
<p class="alignment-block-content alignment-block-content-left epigraph-content"><i>pleasure in a good novel, must be intolerably stupid.</i></p>
<p class="alignment-block-content alignment-block-content-left epigraph-content">— Jane Austen</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?2428ef70